export default "__VITE_ASSET__DiqZ6Xas__"